import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Form, Icon } from 'semantic-ui-react'

import { getImageURL } from 'images'
import { ImageCrop } from 'ui'

import { actions, selectors } from '../redux'

import type { FC } from 'react'

import type { TournamentSchema } from '../schemas/TournamentSchema'

export interface EditProps {
  tournament?: TournamentSchema
}

const Edit: FC<EditProps> = ({ tournament }) => {
  const dispatch = useDispatch()
  const [avatarURL, setAvatarURL] = useState(
    tournament?.avatar?.filename ? getImageURL(tournament?.avatar.filename, '200x200-fit') : '',
  )
  const [avatar, setAvatar] = useState<Blob | undefined>()
  const { loading } = useSelector(selectors.tournament)

  const { formState, handleSubmit, register } = useForm({
    defaultValues: {
      is_active: tournament?.is_active,
      is_ended: tournament?.is_ended,
      is_filled: tournament?.is_filled,
      name: tournament?.name || '',
    },
  })

  const onRemoveAvatar = () => {
    setAvatarURL('')
    setAvatar(undefined)
  }

  const onCutAvatar = (url: string, blob: Blob) => {
    setAvatarURL(url)
    setAvatar(blob)
  }

  const onSubmit = (values: { name: string }) => {
    dispatch(
      actions.tournamentUpdate({
        ...values,
        id: tournament?.id,
        _avatar: !avatar && !avatarURL,
        avatar,
      }),
    )
  }
  return (
    <div className="bg-white p-2">
      <h3>Editar el torneo</h3>
      <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-wrap gap-2 items-start">
          <div className="w-52">
            <ImageCrop
              contentClassName="drop-shadow border"
              cropHeight={200}
              cropWidth={200}
              onCut={onCutAvatar}
              onRemove={onRemoveAvatar}
              readOnly={loading}
              src={avatarURL}
            >
              <div>
                <Icon name="shield" size="big" />
                <br />
                Agrega el escudo de tu equipo
              </div>
            </ImageCrop>
          </div>
          <div className="min-w-72 max-w-96">
            <Form.Input error={formState.errors.name?.message} label="Nombre" readOnly={loading} required>
              <input
                {...register('name', {
                  maxLength: {
                    message: 'Máximo 100 caracteres',
                    value: 100,
                  },
                  required: 'El nombre es requerido',
                })}
                maxLength={100}
                type="text"
              />
            </Form.Input>
            <Form.Input className="flex flex-col" label="" readOnly={loading}>
              <label>
                <span>
                  <input className="!w-10 !max-w-10" {...register('is_active')} type="checkbox" />
                </span>{' '}
                Torneo activo
              </label>
            </Form.Input>
            <Form.Input className="flex flex-col" label="" readOnly={loading}>
              <label>
                <span>
                  <input className="!w-10 !max-w-10" {...register('is_ended')} type="checkbox" />
                </span>{' '}
                Torneo terminado
              </label>
            </Form.Input>
            <Form.Input className="flex flex-col" label="" readOnly={loading}>
              <label>
                <span>
                  <input className="!w-10 !max-w-10" {...register('is_filled')} type="checkbox" />
                </span>{' '}
                Torneo lleno
              </label>
            </Form.Input>
          </div>
        </div>
        <div className="pt-2 mt-2 border-t">
          <Button
            content={loading ? 'Guardando...' : 'Guardar'}
            icon={loading ? 'spinner' : 'save'}
            primary
            readOnly={loading}
            type="submit"
          />
        </div>
      </Form>
    </div>
  )
}

export default Edit
